@if (isDataLoaded) {
  <div class="container">
    <div class="row" style="margin-top: 20px;">
      <img [src]="('assets/images/archipelago-logo-small.png' | sanitizeUrl)" style="width: 70px; height: auto;" />
      <div class="col" align="right">
        <app-menu> </app-menu>
      </div>
    </div>
    @if (!isProduction) {
      <div class="row" style="padding-top: 20px;">
        <b style="font-style: italic;">DEMO MODE</b>
        <small>This app does not send any data or report to DFO and is for demonstration purposes only</small>
      </div>
    }
    @if (adminUser) {
      <div class="admin-box">
        <div class="row">
          <h3 class="blue-subheading">
            You are currently logged in as an Archipelago Admin.
          </h3>
        </div>
        <div class="row" align="left">
          <h6 class="descriptive-text">
            All submission functionality and data syncing to server is disabled. Use the admin panel to manage logbooks, user mappings, and replicate and view a user's data.
          </h6>
          @if (userDetails.isValid()) {
            <h5 class="descriptive-text">
              You are currently viewing {{userDetails.userEmail}}'s trip data
            </h5>
          }
        </div>
      </div>
    }
    @if (hasRegisteredLogbook()) {
      <div>
        <div class="row" style="margin-top: 20px;">
          <h1 i18n class="blue-trip-heading">
        My Trip
      </h1>
        </div>
        @if (hasRegisteredLogbook()) {
          <div class="row">
            <h4 i18n class="blue-subheading">
        You do not have an active trip
      </h4>
          </div>
        }
        <div class="row" style="margin-top: 50px;">
          <div class="col" style="display: flex; justify-content: center;">
            <button i18n mat-stroked-button class="create-button" (click)="toStartReport()">Start new trip to hail out</button>
          </div>
        </div>
      </div>
    }
    @if (hasOnlyInactiveLogbooks() && !adminUser) {
      <div style="margin-top: 30px;">
        <div class="row">
          <h3 i18n class="blue-subheading">
        You do not have an active logbook for this season.
      </h3>
        </div>
        <div class="row" align="left">
          <h6 i18n class="descriptive-text">
        Please contact Archipelago to purchase a logbook for this season.
      </h6>
        </div>
      </div>
    }
    @if (!hasRegisteredLogbook() && !adminUser && !hasOnlyInactiveLogbooks()) {
      <div style="margin-top: 30px;">
        <div class="row">
          <h3 i18n class="blue-subheading">
        You have no available logbooks.
      </h3>
        </div>
        <div class="row" align="left">
          <h6 i18n class="descriptive-text">
        Select the button below to register a vessel
      </h6>
        </div>
        <div class="row" style="margin-top: 50px;">
          <div class="col" style="display: flex; justify-content: center;">
            <button mat-stroked-button class="create-button" (click)="addVesselDialog()">Add Vessel</button>
          </div>
        </div>
      </div>
    }
    @if (hasUnRegisteredLogbook() && !adminUser && !hasOnlyInactiveLogbooks()) {
      <div class="row" align="left">
        <h6 class="descriptive-text">
          A logbook in your account couldn't find a matching VRN from your vessels. Check your profile page
        </h6>
      </div>
    }
  </div>
}
